import React from "react";
const SvgLoginSyncDevices = props => (
  <svg fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M15.683 4a.75.75 0 00-.75-.75H9.24c-2.2 0-3.99 1.79-3.99 3.99v6.093a.75.75 0 001.5 0V7.24a2.494 2.494 0 012.49-2.49h5.693a.75.75 0 00.75-.75zM28 15.502a.75.75 0 00-.75.75v1.081a2.493 2.493 0 01-2.49 2.49H14.667a.75.75 0 000 1.5H24.76c2.2 0 3.99-1.789 3.99-3.99v-1.08a.75.75 0 00-.75-.75z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M20 19.83a.75.75 0 00-.65.837l.6 4.76a.75.75 0 101.487-.188l-.6-4.76a.75.75 0 00-.837-.65z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M23.51 25.333a.75.75 0 00-.75-.75h-8.093a.75.75 0 000 1.5h8.093a.75.75 0 00.75-.75z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M12.938 14.5c.307 0 .562.251.562.568v11.864a.565.565 0 01-.563.568H5.064a.565.565 0 01-.563-.568V15.068c0-.317.255-.568.563-.568h7.875zm2.062.568C15 13.93 14.08 13 12.937 13H5.064A2.065 2.065 0 003 15.068v11.864C3 28.07 3.92 29 5.063 29h7.875A2.065 2.065 0 0015 26.932V15.068z"
      clipRule="evenodd"
    />
    <path
      fill="#E4002B"
      fillRule="evenodd"
      d="M24 15a7 7 0 100-14 7 7 0 000 14z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M27.73 5.174a.75.75 0 01.097 1.056l-3.75 4.5a.75.75 0 01-1.081.075l-2.75-2.5a.75.75 0 111.009-1.11l2.17 1.973 3.25-3.898a.75.75 0 011.056-.096z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLoginSyncDevices;
